import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import classnames from 'classnames';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import CoreBadge from '@wix/da-ds/pkg/Badges/CoreBadge';
import s from './GetCore.scss';

export interface Props {
  className?: string;
}

export const GetCore: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={classnames(s['root'], className)}>
      <Trans i18nKey={'pages.shop.emptyState.nonCore.premiumFolder.getCore'}>
        <BiLink
          href={URLS.CORE_MEMBERSHIP}
          className={s['upgrade-to-core']}
          biData={{
            evid: BiEventType.BUY_CORE_BUTTON,
            referral_info: ReferralType.PAYWALL_PG,
          }}
        >
          Get Core{' '}
        </BiLink>
        <SophisticatedTooltip
          size="medium"
          className={s['core-badge']}
          aria-label={t('pages.shop.emptyState.nonCore.premiumFolder.tooltip')}
          description={t('pages.shop.emptyState.nonCore.premiumFolder.tooltip')}
          postfix={
            <SophisticatedTooltipLink href="https://www.deviantartsupport.com/en/article/what-is-a-core-membership">
              {t('common.learnMore')}
            </SophisticatedTooltipLink>
          }
        >
          <CoreBadge size="small" />
        </SophisticatedTooltip>{' '}
        to Add New
      </Trans>
    </div>
  );
};

export default GetCore;
